// Minimal SpreadsheetML (.xls) builder — same format as the designer procurement
// export, generalized for reuse by the MRP screens.

export const escapeXml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");

export const excelCell = (value, styleId, numeric = false) => {
  const attributes = styleId ? ` ss:StyleID="${styleId}"` : "";
  if (numeric) {
    const numberValue = Number(value);
    if (Number.isFinite(numberValue)) return `<Cell${attributes}><Data ss:Type="Number">${numberValue}</Data></Cell>`;
  }
  return `<Cell${attributes}><Data ss:Type="String">${escapeXml(value)}</Data></Cell>`;
};

export const excelRow = (cells) => `<Row>${cells.join("")}</Row>`;

// sheets: [{ name, rowsXml }]
export const buildWorkbookXml = (sheets) => `<?xml version="1.0"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:o="urn:schemas-microsoft-com:office:office"
 xmlns:x="urn:schemas-microsoft-com:office:excel"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:html="http://www.w3.org/TR/REC-html40">
 <Styles>
  <Style ss:ID="Title"><Font ss:Bold="1" ss:Size="14" /></Style>
  <Style ss:ID="Header"><Font ss:Bold="1" /><Interior ss:Color="#D9EAF7" ss:Pattern="Solid" /></Style>
  <Style ss:ID="Group"><Font ss:Bold="1" /><Interior ss:Color="#F6F6F7" ss:Pattern="Solid" /></Style>
  <Style ss:ID="Late"><Font ss:Bold="1" ss:Color="#B00020" /></Style>
 </Styles>
 ${sheets.map((sheet) => `<Worksheet ss:Name="${escapeXml(sheet.name)}"><Table>${sheet.rowsXml}</Table></Worksheet>`).join("\n ")}
</Workbook>`;

export const downloadWorkbook = (workbookXml, filename) => {
  const blob = new Blob([workbookXml], { type: "application/vnd.ms-excel;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
